import { isDev } from "./host";

export const FILE_UPLOAD_URL = `https://api.unifylist.com/ud_service/v1/file/upload`;

export const GQL_URI =
  import.meta.env.VITE_GQL_URI ?? `https://${isDev ? "dev" : ""}api.unifylist.com/api_gateway`;

export const GOOGLE_MAPS_API_KEY = "AIzaSyDOW1qDSuwlibtnDyz1aFZCEkdQKLOEhsg";

export const AI_SERVICE_API =
  import.meta.env.VITE_AI_SERVICE_API ?? `https://api.unifylist.com/ai_service/api/unify/sessions`;
